<script lang="ts">
  import DefectManager from '@surahammars/defect-manager'
  import GenealogyOverview from '@surahammars/genealogy-manager'
  import OperationsManager from '@surahammars/operations-manager'
  import Base from '@factry/base'
  import DowntimeManager from '@factry/downtime-manager'
  import EquipmentManager from '@factry/equipment-manager'
  import InstructionManager from '@factry/instruction-manager'
  import MaterialManager from '@factry/material-manager'
  import MessageQueueManager from '@factry/message-queue-manager'
  import MPSManager from '@factry/mps-manager'
  import OrderManager from '@factry/order-manager'
  import ReportManager from '@factry/report-manager'
  import ShiftManager from '@factry/shift-manager'
  import TeamManager from '@factry/team-manager'
  import WarehouseManager from '@factry/warehouse-manager'
  import WasteManager from '@factry/waste-manager'
</script>

<Base
  options={[
    EquipmentManager, InstructionManager, ShiftManager, WasteManager,
    MPSManager, DowntimeManager, TeamManager, MessageQueueManager,
    MaterialManager, OperationsManager, OrderManager,
    DefectManager, GenealogyOverview, WarehouseManager, ReportManager,
  ]}
/>
